import { fetchWithAuth } from "../api/client";
import { AccessCode, EmptyResponse, ErrorResponse } from "../types";

export async function getCodes(token: string): Promise<AccessCode[]> {
  const res = await fetchWithAuth("Code", {
    method: "GET",
    token,
  });

  if (!res.ok) {
    throw new Error(`Error fetching codes: ${res.statusText}`);
  }

  const data = await res.json();

  return data.map(
    (c: any): AccessCode => ({
      id: c.id,
      surveyId: c.surveyId,
      surveyTitle: c.surveyTitle,
      code: c.code,
      isActive: c.isActive ?? false,
      createdAt: c.createdAt,
      organizationId: c.organizationId,
      organizationName: c.organizationName,
      questionCount: c.questionCount,
      type: c.type,
    })
  );
}
export async function setCodeStatus(
  token: string,
  id: string,
  isActive: boolean
): Promise<ErrorResponse | EmptyResponse> {
  try {
    const res = await fetchWithAuth(`Code/${id}/code-status`, {
      method: "PATCH",
      token,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(isActive),
    });
    if (!res.ok) {
      const errorMessage = await res.text();
      return {
        error: res.status,
        message: errorMessage,
      };
    }

    const text = await res.text();
    return { ok: res.ok, message: text || "Access code updated successfully" };
  } catch (err: any) {
    return {
      error: 500,
      message: err.message,
    };
  }
}
